import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'caravan/projectTaskResPlanner';

const projectTaskResourcePlannerService = {
  getTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task`,
      data,
    });
  },

  getProjects: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/projects`,
      data,
    });
  },

  updateTask: (data, simpleTaskId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/task/${encodeURIComponent(simpleTaskId)}`,
      data,
    });
  },

  deleteTask: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/task/${encodeURIComponent(id)}`,
    });
  },

  searchTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/search`,
      data,
    });
  },
};
export default projectTaskResourcePlannerService;
